import styled from 'styled-components';

const Styled = styled.div`
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	background-color: ${({ theme }) => theme.v2.color.white[500]};
	padding: 1.5rem;
	border-radius: 8px;
	${({ theme }) => theme.shadow.z3}
`;

export { Styled as Box };
